import request from '@/utils/request';

export async function queryUserLastOper() {
  return request('/users/lastoper');
}

export async function queryUserLastLogin() {
  return request('/users/lastlogin');
}
export async function queryUserPortlets(portalId) {
  return request(`/portals/${portalId}/user/portlets`);
}

export async function queryUserFavorites(portalId) {
  return request(`/portals/${portalId}/user/favorites`);
}

export async function queryDashboardLayout(portalId) {
  return request(`/portals/${portalId}/layouts/default`);
}

export async function saveDashboardLayout({ portalId, params, method }) {
  return request(`/portals/${portalId}/layouts`, {
    method,
    body: params,
  });
}

export async function setDefaultLayout({ portalId, LayoutId }) {
  return request(`/portals/${portalId}/layouts/${LayoutId}/default`, {
    method: 'PATCH',
  });
}

export async function getOSType() {
  return request('/browser/getOSType');
}

export async function getBrowserType() {
  return request('/browser/getBrowserType');
}

export async function getScreenType() {
  return request('/browser/getScreen');
}

export async function queryMenuLayouts(portalId, menuId) {
  return request(`/portals/${portalId}/menuId/${menuId}/layouts`);
}

export async function saveMenuLayout({ portalId, menuId, params, method }) {
  return request(`/portals/${portalId}/menuId/${menuId}/layouts`, {
    method,
    body: params,
  });
}

export async function modMenuLayout({ portalId, layoutId, params, method }) {
  return request(`/portals/${portalId}/layouts`, {
    method,
    body: {
      layoutId,
      ...params,
    },
  });
}

export async function queryMenuPortlets(menuId) {
  return request(`/menus/${menuId}/user/portlets`);
}
